import { useMap } from "@vis.gl/react-google-maps";
import { CustomMarker } from "./CustomMarker";

//pointOfInterest = {key:"", location:{lat:0.00, lng:0.00}}
export const PoiMarkers = ({
  pointsOfInterest,
  hoveredMarker,
  assignOrders,
  clickable,
}) => {
  //   console.log("hovered marker", hoveredMarker);
  const map = useMap();
  //   console.log("map", map);
  // console.log(
  //   "why isn't hovering working",
  //   pointsOfInterest[0]?.locationKey,
  //   hoveredMarker
  // );
  return pointsOfInterest.map((pointOfInterest) => {
    return (
      <CustomMarker
        key={pointOfInterest.key}
        hovered={hoveredMarker && pointOfInterest.locationKey === hoveredMarker}
        pointOfInterest={pointOfInterest}
        clickable={clickable}
        handleAssignOrders={assignOrders}
        {...pointOfInterest.markerProps}
      />
    );
  });
};
